"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

require("./spinner.sass");

var _ref2 = _react.default.createElement("div", {
  className: "spinner"
}, _react.default.createElement("svg", {
  className: "spinner-element",
  viewBox: "0 0 28 28"
}, _react.default.createElement("circle", {
  className: "spinner-path",
  cx: "14",
  cy: "14",
  r: "11",
  fill: "none"
})));

var Spinner = function Spinner(_ref) {
  var small = _ref.small,
      className = _ref.className,
      message = _ref.message;
  return _react.default.createElement("div", {
    className: (0, _classnames.default)('spinner-container', {
      'spinner-container--small': small
    }, className)
  }, _ref2, message && _react.default.createElement("p", {
    className: "spinner-message"
  }, message));
};

Spinner.propTypes = process.env.NODE_ENV !== "production" ? {
  small: _propTypes.default.bool,
  message: _propTypes.default.node,
  className: _propTypes.default.any
} : {};
var _default = Spinner;
exports.default = _default;